import { nodeRestApi } from '@/plugins/api';

export default {
  async fetchEcotronList(
    { commit },
    { page = 1, limit = 10, search = '' } = {}
  ) {
    commit('setError', false, { root: true });
    commit('setEcotronLoading', true);

    try {
      // Build params object
      const params = {
        page,
        limit
      };

      // Only add search if it has value
      if (search && search.trim() !== '') {
        params.search = search;
      }

      const response = await nodeRestApi.get('ecotron/list/paginated', {
        params: params
      });

      if (response.data.success) {
        const ecotronList = response.data.data.map(device => {
          return {
            deviceType: 'ecotron',
            ...device,
            topic: device.Topic || device.topic
          };
        });

        commit('setEcotronList', ecotronList);
        commit('setEcotronPagination', response.data.pagination);
        return ecotronList;
      }

      return [];
    } catch (error) {
      if (error.isAxiosError) {
        if (error.response) {
          commit('setError', error.response.data.error.message, { root: true });
        }
      } else {
        commit('setError', error, { root: true });
      }
    } finally {
      commit('setEcotronLoading', false);
    }
  },

  async fetchEcotronPage(
    { commit },
    { page = 1, limit = 10, search = '' } = {}
  ) {
    try {
      const params = {
        page,
        limit
      };

      if (search && search.trim() !== '') {
        params.search = search;
      }

      const response = await nodeRestApi.get('ecotron/list/paginated', {
        params
      });

      if (response.data.success) {
        return response.data.data.map(device => ({
          deviceType: 'ecotron',
          ...device,
          topic: device.Topic || device.topic
        }));
      }

      return [];
    } catch (error) {
      return [];
    }
  },

  async fetchEcotronCurrent({ commit }, topic) {
    commit('setError', false, { root: true });

    try {
      const response = await nodeRestApi.get(`ecotron/${topic}`);
      const ecotronCurrent = response.data;
      commit('setEcotronCurrent', ecotronCurrent);
    } catch (error) {
      if (error.isAxiosError) {
        if (error.response) {
          commit('setError', error.response.data.error.message, { root: true });
        }
      } else {
        commit('setError', error, { root: true });
      }
    }
  }
};
